/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Landing_Pricing_Toggle_Yearly_SaveInputs */

const tr_landing_pricing_toggle_yearly_save = /** @type {(inputs: Landing_Pricing_Toggle_Yearly_SaveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-%${i?.percent}`)
};

const en_landing_pricing_toggle_yearly_save = /** @type {(inputs: Landing_Pricing_Toggle_Yearly_SaveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-${i?.percent}%`)
};

const de_landing_pricing_toggle_yearly_save = /** @type {(inputs: Landing_Pricing_Toggle_Yearly_SaveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-${i?.percent}%`)
};

const ru_landing_pricing_toggle_yearly_save = /** @type {(inputs: Landing_Pricing_Toggle_Yearly_SaveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`-${i?.percent}%`)
};

/**
* | output |
* | --- |
* | "-{percent}%" |
*
* @param {Landing_Pricing_Toggle_Yearly_SaveInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricing_toggle_yearly_save = /** @type {((inputs: Landing_Pricing_Toggle_Yearly_SaveInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Toggle_Yearly_SaveInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_toggle_yearly_save(inputs)
	if (locale === "de") return de_landing_pricing_toggle_yearly_save(inputs)
	if (locale === "ru") return ru_landing_pricing_toggle_yearly_save(inputs)
	return tr_landing_pricing_toggle_yearly_save(inputs)
});